import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Spin } from "antd";
import { Title, Button } from "@vshp/ui-components";
import PostCard from "../../components/posts/PostCard";
import postsBg from "../../../public/images/hero.jpg";
import { loadingIcon } from "../../components/utils/svg";
import { fetchPosts, fetchPostsLoadMore } from "../../actions/posts";
import { wrapper } from "../../store";
import Image from "next/image";
import Head from "next/head";

export const getServerSideProps = wrapper.getServerSideProps((store) => async () => {
  await store.dispatch(fetchPosts());
});

const Posts = () => {
  const dispatch = useDispatch();
  const { posts, postsMoreAreLoading } = useSelector((state) => state.posts);

  const handleLoadMore = () => {
    dispatch(fetchPostsLoadMore(posts.links.next));
  };

  return (
    <>
      <Head>
        <title>Новости</title>
      </Head>
      <div className="page__header">
        <Image className="page__header-cover" src={postsBg} alt="Новости" priority={false} />
        <div className="page__header-body page__header-body_center">
          <Title decor={false} className="page__header-title">
            Новости
          </Title>
        </div>
      </div>

      <div className="page__blocks">
        <div className="page__block">
          <div className="posts-feed">
            <div className="posts-feed__wrapper">
              {posts.data.map((post, id) => (
                <PostCard item={post} key={id} />
              ))}
            </div>
            {posts.links.next && (
              <div className="text-center">
                <Button maxWidth={true} className="post__more" onClick={handleLoadMore}>
                  {postsMoreAreLoading ? <Spin indicator={loadingIcon} /> : "Загрузить ещё"}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Posts;
